import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AddressDTO, PersonDTO } from '@iota/iota-management-portal-v4-client';
import { getPersonEmail, getPersonPhoneNumber, parseMainAddress } from '../../utils';

@Component({
    standalone: false,
    selector: 'app-person-card',
    templateUrl: './person-card.component.html',
    styleUrls: ['./person-card.component.scss']
})
export class PersonCardComponent {
    @Input() person: PersonDTO;
    @Output() cardClicked = new EventEmitter<string>();
    @Output() deleteClicked = new EventEmitter<string>();

    getPersonEmail(person: PersonDTO): string {
        return getPersonEmail(person).email;
    }

    getPersonPhoneNumber(person: PersonDTO): string {
        return getPersonPhoneNumber(person).phoneNumber;
    }

    parseAddress(address: AddressDTO[]): string {
        return parseMainAddress(address);
    }
}
